export class DialogModelDROpenItemsSpokeFilter {
    constructor(
        private data: any
    ) {}
  }